/** Planner assessment changes invalidate caches and prompt saved-route refreshes
 * independently of stored resort scoring. Version 9 closes every run of a closed
 * resort (a fresh area closure or the member's stored v3 status) with no engine
 * call, reading "Out of season" for a season closure, and never labels a run the
 * engine closes without an operator report "reported closed". Version 8 marks
 * reported-closed and confirmed-bare runs Closed in both assemble paths (no
 * published score, the value kept only as "if open" detail) and scores runs with
 * the ski v3 engine once revision 3 is published. Version 7 corrected station
 * elevation references and sub-hour evidence availability in shared snow scoring. */
export const PLANNER_ASSESSMENT_VERSION = 9;
